import React, { useEffect, useState, useRef } from 'react';

import { Assignment } from '@material-ui/icons';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import { ConstantPermissions } from 'contexts/useConstant';

import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { useParams } from 'react-router-dom';

import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsGet, wsCreate, wsUpdate, wsFindBy, wsDownload, wsPost } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';
import DetailKardex from './DetailKardex';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import SweetAlert from 'react-bootstrap-sweetalert';
import { InventoryHeader } from './Components/InventoryHeader';
import ModalOuput from './Modal/ModalOuput';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { wsGetPdfPromise } from 'services/WService';
import { wsUrl } from 'services/WService';

const useStyles = makeStyles({
  ...styles,
  closeButton: {
    float: 'right'
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  },
});

const entity = 'logi/inventory';
const type = 'GN';

const permission = {
  store:
    type === 'GN' === 'LOGI_ENTRIES_STORE',
  update:
    type === 'GN' === 'LOGI_ENTRIES_UPDATE',
  confirm:
    type === 'GN' === 'LOGI_ENTRIES_CONFIRM',
  show:
    type === 'GN' === 'LOGI_INVENTORIES_SHOW',
  delete:
    type === 'GN' === 'LOGI_INVENTORIES_DELETE',
};

export default WithApp(function Transfer(props) {
  const classes = useStyles();
  const { id } = useParams();
  const inventoryTaking = props.model;
  const [notify, showNotify] = useToasty();
  const [productSelecteds, setProductSelecteds] = useState([]);
  const [dataInitial, setDataInitial] = useState({});
  const [stateK, setStateK] = useState(false);
  const [stateA, setStateA] = useState(false);
  const [openModalOutput, setOpenModalOutput] = useState(false);
  const [dataChanging, setDataChanging] = useState({
    ...inventoryTaking
  });
  const [showProducts, setShowProducts] = useState(dataChanging?.state !== 'BORRADOR'); 
  const [stateAprove, setStateAprove] = useState(dataChanging?.state === 'PENDIENTE_APROBACION');
  const [stateProduct, setStateProduct] = useState(
    !(dataChanging?.state === 'PENDIENTE_FIRMA' || dataChanging?.state === 'BORRADOR')
  );  

  const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedMarks, setSelectedMarks] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedLines, setSelectedLines] = useState([]);
  const [selectedFamilies, setSelectedFamilies] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  const inputPdf = useRef(null);
  const [namePdf, setNamePdf] = useState('');
  const [alert, setAlert] = useState(null);
  const [alertAprove, setAlertAprove] = useState(null);

  const [providers, setProviders] = useState([]);
  const [zones, setZones] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [marks, setMark] = useState([]);
  const [categories, setCategories] = useState([]);
  const [lines, setLines] = useState([]);
  const [families, setFamilies] = useState([]);
  const [products, setProducts] = useState([]);
  const [jefeDia, setJefeDia] = useState([]);
  const [jefeNoche, setJefeNoche] = useState([]);
  const [auditor, setAuditor] = useState([]);
  const isInitializingWithId = useRef(false);
  const isInitializing = useRef(true);

  const [showProvidersInfo, setShowProvidersInfo] = useState(true);
  const [showMarksInfo, setShowMarksInfo] = useState(true);
  const [showCategoriesInfo, setShowCategoriesInfo] = useState(true);
  const [showLinesInfo, setShowLinesInfo] = useState(true);
  const [showFamiliesInfo, setShowFamiliesInfo] = useState(true);
  const [showProdStock, setShowProdStock] = useState(false);

  const [openPDF, setOpenPDF] = useState(false);
  const [urlPDF, setURLPDF] = useState('');

  const [modalData, setModalData] = useState({});
  
  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function updateHeaderField(field, value) {
    handleChange(field, value);
    if (!dataChanging.id) return;
    const userFields = ['jefe_almacen_dia_id', 'jefe_almacen_noche_id', 'auditor_id'];
    let response;
    if (userFields.includes(field)) {
      response = await wsUpdate(`${entity}/${dataChanging.id}/update-users`, { [field]: value });
    } else {
      response = await wsUpdate(entity, dataChanging.id, { [field]: value });
    }
    if (response.success) {
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  const filterProductsByDifference = (condition) => {
    return dataChanging.details
      .flatMap(detail => detail.marks)
      .flatMap(mark => mark.lines)
      .flatMap(line => line.families)
      .flatMap(family => family.details)
      .filter(product => condition(parseFloat(product.diferencia)))
      .map(product => ({
        logi_product_id: product.logi_product_id,
        quantity: Math.abs(parseFloat(product.diferencia))
      }));
  };

  async function listProviders() {
    setDataLoading(true);
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
    setDataLoading(false);
  }

  async function listZones() {
    setDataLoading(true);
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
    setDataLoading(false);
  }

  async function listWarehouses(logiWarehouseId) {
    if (!logiWarehouseId) {
      setWarehouses([]);
      return;
    }
    setDataLoading(true);
    let response = await wsFindBy('logi/warehouse', { id: logiWarehouseId, warehouse_type: 'N' });
    if (response.success) {
      setWarehouses(response.data);
    }
    setDataLoading(false);
  }

  async function listJefeDia() {
    setDataLoading(true);
    let response = await wsFindBy('logi/inventory-manager', { type: 'JD', base_zone_id: dataChanging.base_zone_id });
    if (response.success) setJefeDia(response.data);
    setDataLoading(false);
  }
  async function listJefeNoche() {
    setDataLoading(true);
    let response = await wsFindBy('logi/inventory-manager', { type: 'JN', base_zone_id: dataChanging.base_zone_id });
    if (response.success) setJefeNoche(response.data);
    setDataLoading(false);
  }
  async function listAuditor() {
    setDataLoading(true);
    let response = await wsFindBy('logi/inventory-manager', { type: 'AD', base_zone_id: dataChanging.base_zone_id });
    if (response.success) setAuditor(response.data);
    setDataLoading(false);
  }

  async function listMarks(providerIds) {
    if (!providerIds || providerIds.length === 0) {
      setMark([]);
      return;
    }
    setDataLoading(true);
    let response = await wsFindBy('logi/provider-marks', { base_business_partner_id: providerIds });
    if (response.success) setMark(response.data);
    setDataLoading(false);
  }

  async function listCategories(providerIds) {
    if (!providerIds || providerIds.length === 0) {
      setCategories([]);
      return;
    }
    setDataLoading(true);
    let response = await wsFindBy('logi/category-multiple', {
      base_business_partner_id: providerIds,
      state: 'A',
      deleted_at: 'null'
    });
    if (response.success) setCategories(response.data);
    setDataLoading(false);
  }

  async function listLines(categoryIds) {
    if (!categoryIds || categoryIds.length === 0) {
      setLines([]);
      return;
    }
    setDataLoading(true);
    let response = await wsFindBy('logi/line', { logi_category_id: categoryIds, state: 'A', deleted_at: 'null' });
    if (response.success) setLines(response.data);
    setDataLoading(false);
  }

  async function listFamilies(lineIds) {
    if (!lineIds || lineIds.length === 0) {
      setFamilies([]);
      return;
    }
    setDataLoading(true);
    let response = await wsFindBy('logi/family', { logi_line_id: lineIds, state: 'A', deleted_at: 'null' });
    if (response.success) setFamilies(response.data);
    setDataLoading(false);
  }

  async function listProducts(familyIds) {
    if (!familyIds || familyIds.length === 0) {
      setProducts([]);
      return;
    }
    let response = await wsFindBy('logi/product', { logi_family_id: familyIds, state: 'A', deleted_at: 'null' });
    if (response.success) setProducts(response.data);
  }

  async function saveTransfer() {
    setDataLoading(true);
    let response = await wsCreate(entity, dataChanging);
    if (response.success) {
      window.history.replaceState('', '', `${response.data.id}?type=${type}`);
      // getTransfer(response.data.id);
      showNotify(response.message);
      window.location.reload();
    } else {
      showNotify(response.message, 'error');
    }
    setDataLoading(false);
  }

  async function updateTransfer() {
    let newData = {};
    for (let key in dataChanging) {
      if (dataInitial[key] != dataChanging[key]) {
        newData[key] = dataChanging[key];
      }
    }

    if (Object.keys(newData).length < 1) return;
    setDataLoading(true);
    let response = await wsUpdate(entity, dataChanging.id, newData);
    if (response.success) {
      // getTransfer(response.data.id);
      showNotify(response.message);
      window.location.reload();
    } else {
      showNotify(response.message, 'error');
    }
    setDataLoading(false);
  }

  const hideAlert = () => {
    setAlert(null);
  };
  const hideAlertAprove = () => {
    setAlertAprove(null);
  };

  function confirmSendPDF(fileName) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={`¿Está seguro de guardar el PDF "${fileName}"?`}
        onConfirm={() => {
          saveFiles();
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }
  async function generateExpiringInventory() {
    let response = await wsPost('logi/inventory-generate-expiring', {
      base_zone_id: dataChanging.base_zone_id,
      logi_warehouse_id: dataChanging.logi_warehouse_id,
      jefe_almacen_dia_id: dataChanging.jefe_almacen_dia_id ?? null,
      jefe_almacen_noche_id: dataChanging.jefe_almacen_noche_id ?? null,
      auditor_id: dataChanging.auditor_id ?? null,
      comments: dataChanging.comments ?? null,
    });
    if (response.success) {
      showNotify(response.message);
      if (response.data?.id) {
        window.location.href = `/admin/inventario/toma-inventario/registro-inventario/${response.data.id}?type=${type}`;
      }
    } else {
      showNotify(response.message, 'error');
    }
  }

  function confirmGenerateExpiring() {
    if (!dataChanging.base_zone_id || !dataChanging.logi_warehouse_id) {
      showNotify('Escoge una zona/almacén para generar la toma de vencimiento', 'info');
      return;
    }
    setAlertAprove(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Generar toma con productos por vencer?"
        onConfirm={() => {
          generateExpiringInventory();
          hideAlertAprove();
        }}
        onCancel={() => hideAlertAprove()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Generar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Se creará una toma de inventario en BORRADOR con todos los productos apartados por vencer.
      </SweetAlert>
    );
  }

  function confirmChangeState(state) {
    setAlertAprove(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={'¿Está seguro de cambiar el estado de la toma de inventario?'}
        onConfirm={() => {
            changeStateK(state);
            hideAlertAprove();
        }}
        onCancel={() => hideAlertAprove()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }
  

  async function saveFiles() {
    if (inputPdf.current.files.length == 0) {
      showNotify('Seleccione Archivo PDF', 'info');
      return;
    }

    let fd = new FormData();
    fd.append('pdf', inputPdf.current.files[0]);
    setDataLoading(true);
    let response = await wsPost(`${entity}/${dataChanging.id}/store-pdf`, fd);
    if (response.success) {
      inputPdf.current.value = '';
      setNamePdf('');
      changeStateK('GENERADO');
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
    setDataLoading(false);
  }

  useEffect(() => {
    listProviders();
    // listMarks();
    if (!isInitializingWithId.current) {
      listZones();
    }
  }, []);

  useEffect(() => {
    if (dataChanging?.base_zone_id) {
      handleChange("jefe_almacen_dia_id", "");
      handleChange("jefe_almacen_noche_id", "");
      handleChange("auditor_id", "");
      
      setJefeDia([]);
      setJefeNoche([]);
      setAuditor([]);
      
      listJefeDia();
      listJefeNoche();
      listAuditor();
    }
  }, [dataChanging?.base_zone_id]);

  useEffect(() => {
    if (id && providers.length > 0) {
      getTransfer(id);
    }
  }, [id, providers]);

  // 🟢
  useEffect(() => {
    if (!dataChanging?.providers?.length || providers.length === 0) return;

    const selectedProviders = providers.filter((p) =>
      dataChanging.providers.includes(p.CardName)
    );
    if (selectedProviders.length > 0) {
      const selectedProviderId = selectedProviders.map((p) => p.id);
      setSelectedProviders(selectedProviders);
      handleChange("providers", selectedProviderId);
      listCategories(selectedProviderId);
      listMarks(selectedProviderId);
    }
  }, [dataChanging.providers]);

  // 🟢
  useEffect(() => {
    if (!dataChanging?.marks?.length || marks.length === 0) return;

    const selectedMarks = marks.filter((m) =>
      dataChanging.marks.includes(m.logi_mark_description)
    );

    if (selectedMarks.length > 0) {
      const selectedMarksId = selectedMarks.map((m) => m.logi_mark_id);
      setSelectedMarks(selectedMarks);
      handleChange("marks", selectedMarksId);
    }
  }, [marks]);

  // 🟢
  useEffect(() => {
    if (!dataChanging?.categories?.length || categories.length === 0) return;

    const selectedCategories = categories.filter((c) =>
      dataChanging.categories.includes(c.description)
    );
    if (selectedCategories.length > 0) {
      const selectedCategoriesId = selectedCategories.map((c) => c.id);
      setSelectedCategories(selectedCategories);
      handleChange("categories", selectedCategoriesId);
      listLines(selectedCategoriesId);
    }
  }, [categories]);

  // 🟢
  useEffect(() => {
    if (!dataChanging?.lines?.length || lines.length === 0) return;

    const selectedLines = lines.filter((l) =>
      dataChanging.lines.includes(l.description)
    );
    if (selectedLines.length > 0) {
      const selectedLinesId = selectedLines.map((l) => l.id);
      setSelectedLines(selectedLines);
      handleChange("lines", selectedLinesId);
      listFamilies(selectedLinesId);
    }
  }, [lines]);

  // 🟢
  useEffect(() => {
    if (!dataChanging?.families?.length || families.length === 0) return;
  
    const selectedFamilies = families.filter((f) =>
      dataChanging.families.includes(f.description)
    );
  
    if (selectedFamilies.length > 0) {
      const selectedFamiliesId = selectedFamilies.map((f) => f.id);
      setSelectedFamilies(selectedFamilies);
      handleChange("families", selectedFamiliesId);
    }
    isInitializing.current = false;
    // if(!isInitializing.current) console.log("Carga inicial completada");
  }, [families]);

  // 🟢
  useEffect(() => {
    if (!dataChanging?.products?.length || products.length === 0) return;

    const selectedProducts = products.filter((pr) =>
      dataChanging.products.includes(pr.ItemName)
    );
    if (selectedProducts.length > 0) {
      const selectedProductsId = selectedProducts.map((pr) => pr.id);
      setSelectedProducts(selectedProducts);
      handleChange("products", selectedProductsId);
    }
    
  }, [products]);  
  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      const providerIds = selectedProviders.map(p => p.id);
      handleChange("providers", providerIds);
      listCategories(providerIds);
      listMarks(providerIds);
      if(providerIds.length === 0) {
        setSelectedMarks([]);
        setSelectedCategories([]);
      }
    }
  }, [selectedProviders]);

  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      if (!dataChanging?.categories?.length || categories.length === 0) return;

      const selectedCategories = categories.filter((c) => dataChanging.categories.includes(c.id));
      const selectedCategoriesId = selectedCategories.map((c) => c.id);

      setSelectedCategories(selectedCategories);
      if (selectedCategories.length > 0) {
        setSelectedCategories(selectedCategories);
        handleChange("categories", selectedCategoriesId);
      }
    } 
  }, [categories]);
  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      const categoriesIds = selectedCategories.map((c) => c.id);
      handleChange("categories", categoriesIds);
      listLines(categoriesIds);
      if(categoriesIds.length === 0) {
        setSelectedLines([]);
      }
    }
  }, [selectedCategories]);

  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      if (!dataChanging?.marks?.length || marks.length === 0) return;

      const selectedMarks = marks.filter((m) =>
        dataChanging.marks.includes(m.logi_mark_id)
      );

      const selectedMarksId = selectedMarks.map((m) => m.logi_mark_id);
      setSelectedMarks(selectedMarks);
      if (selectedMarks.length > 0) {
        setSelectedMarks(selectedMarks);
        handleChange("marks", selectedMarksId);
      }
    } 
  }, [marks]);
  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      const marksIds = selectedMarks.map((m) => m.logi_mark_id);
      handleChange("marks", marksIds);
    }
  }, [selectedMarks]);

  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      if (!dataChanging?.lines?.length || lines.length === 0) return;

      const selectedLines = lines.filter((l) => dataChanging.lines.includes(l.id));
      const selectedLinesId = selectedLines.map((l) => l.id);

      setSelectedLines(selectedLines);
      if (selectedLines.length > 0) {
        setSelectedLines(selectedLines);
        handleChange("lines", selectedLinesId);
      }
    } 
  }, [lines]);
  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      const linesIds = selectedLines.map((l) => l.id);
      handleChange("lines", linesIds);
      listFamilies(linesIds);
      if(linesIds.length === 0) {
        setSelectedFamilies([]);
      }
    }
  }, [selectedLines]);

  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      if (!dataChanging?.families?.length || families.length === 0) return;

      const selectedFamilies = families.filter((f) => dataChanging.families.includes(f.id));
      // const selectedFamilies = families.filter((f) => dataChanging.families.includes(f.description));
      const selectedFamiliesId = selectedFamilies.map((f) => f.id);

      if (selectedFamilies.length > 0) {
        setSelectedFamilies(selectedFamilies);
        handleChange("families", selectedFamiliesId);
      }
    }
  }, [families]);

  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
        const familiesIds = selectedFamilies.map((f) => f.id);
        handleChange("families", familiesIds);
    }
  }, [selectedFamilies]);
  

  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      if (!dataChanging?.products?.length || products.length === 0) return;

      const selectedProducts = products.filter((pr) => dataChanging.products.includes(pr.id));
      const selectedProductsId = selectedProducts.map((pr) => pr.id);

      setSelectedProducts(selectedProducts);
      if (selectedProducts.length > 0) {
        handleChange("products", selectedProductsId);
      }
    }
  }, [products]);

  // 🔴
  useEffect(() => {
    if (!isInitializing.current && isInitializingWithId.current) {
      // setTimeout(() => {
        const productsIds = selectedProducts.map((pr) => pr.id);
        handleChange("products", productsIds);
      // }, 1000);
    }
  }, [selectedProducts]);


//  --------------------------------------
// si no tiene id el registro
 // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedProviders.length > 0*/) {
      const providerIds = selectedProviders.map(prv => prv.id);
      handleChange("providers", providerIds);
      listCategories(providerIds);
      listMarks(providerIds);
      if(providerIds.length === 0) {
        setSelectedMarks([]);
        setSelectedCategories([]);
      }
    }
  }, [selectedProviders]);

  // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedMarks.length > 0*/) {
      if (!dataChanging?.categories?.length || categories.length === 0) return;

      const selectedCategories = categories.filter((c) =>
        dataChanging.categories.includes(c.id)
      );

      const selectedCategoriesId = selectedCategories.map((c) => c.id);
      setSelectedCategories(selectedCategories);
      if (selectedCategories.length > 0) {
        handleChange("categories", selectedCategoriesId);
      }
    } 
  }, [categories]);
  // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedCategories.length > 0*/) {
      const categoriesIds = selectedCategories.map(p => p.id);
      handleChange("categories", categoriesIds);
      listLines(categoriesIds);
      if(categoriesIds.length === 0) {
        setSelectedLines([]);
      }
    }
  }, [selectedCategories]);

  // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedMarks.length > 0*/) {
      if (!dataChanging?.marks?.length || marks.length === 0) return;

      const selectedMarks = marks.filter((m) =>
        dataChanging.marks.includes(m.logi_mark_id)
      );

      const selectedMarksId = selectedMarks.map((m) => m.logi_mark_id);
      setSelectedMarks(selectedMarks);
      if (selectedMarks.length > 0) {
        handleChange("marks", selectedMarksId);
      }
    } 
  }, [marks]);
  // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedMarks.length > 0*/) {
      const marksIds = selectedMarks.map(m => m.logi_mark_id);
      handleChange("marks", marksIds);
    }
  }, [selectedMarks]);

  // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedLines.length > 0*/) {
      if (!dataChanging?.lines?.length || lines.length === 0) return;

      const selectedLines = lines.filter((l) =>
        dataChanging.lines.includes(l.id)
      );

      const selectedLinesId = selectedLines.map((l) => l.id);
      setSelectedLines(selectedLines);
      if (selectedLines.length > 0) {
        handleChange("lines", selectedLinesId);
      }
    } 
  }, [lines]);
  // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedLines.length > 0*/) {
      const linesIds = selectedLines.map(p => p.id);
      handleChange("lines", linesIds);
      listFamilies(linesIds);
      if(linesIds.length === 0) {
        setSelectedFamilies([]);
      }
    }
  }, [selectedLines]);

  // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedLines.length > 0*/) {
      if (!dataChanging?.families?.length || families.length === 0) return;

      const selectedFamilies = families.filter((f) =>
        dataChanging.families.includes(f.id)
      );

      const selectedFamiliesId = selectedFamilies.map((f) => f.id);
      if (selectedFamilies.length > 0) {
        setSelectedFamilies(selectedFamilies);
        handleChange("families", selectedFamiliesId);
      }
    } 
  }, [families]);
  // 🟣
  useEffect(() => {
    if (!isInitializingWithId.current /*&& selectedFamilies.length > 0*/) {
      const familiesIds = selectedFamilies.map(p => p.id);
      handleChange("families", familiesIds);
      // listProducts(familiesIds);
    }
  }, [selectedFamilies]);

  useEffect(() => {
    if (!isInitializingWithId.current && selectedProducts.length > 0) {
      const productIds = selectedProducts.map(p => p.id);
      handleChange("products", productIds);
    }
  }, [selectedProducts]);

  async function getTransfer(idTransfer) {
    isInitializingWithId.current = true;
    try {
      setDataLoading(true);
      const response = await wsGet(entity, idTransfer);
      if (!response.success || !response.data) {
        throw new Error("Datos no válidos");
      }
      setDataLoading(false);

      const data = response.data;

      const parseStringToArray = (value) => (value ? value.split(",").map((s) => s.trim()) : []);
      data.providers = parseStringToArray(data.providers);
      data.marks = parseStringToArray(data.marks);
      data.categories = parseStringToArray(data.categories);
      data.lines = parseStringToArray(data.lines);
      data.families = parseStringToArray(data.families);
      data.products = parseStringToArray(data.products);

      setDataChanging(data);
      setStateK(data?.state === "BORRADOR" ? false : true);
      setStateA(data?.state === "APROBADO" ? false : true);
      listZones();
    } catch (error) {
      console.error("❌ Error cargando transferencia:", error);
      setDataChanging({});
      setStateK(false);
    }
  }

  async function changeStateK(state) {
    setDataLoading(true);
    let response = await wsUpdate(`${entity}/${dataChanging.id}/update-state`, {
      state: state
    });
    if (response.success) {
      showNotify(response.message);
      getTransfer(dataChanging.id);
    } else {
      showNotify(response.message, 'error');
    }
    setDataLoading(false);
  }

  async function updateUsers(values) {
    setDataLoading(true);
    let response = await wsUpdate(`${entity}/${dataChanging.id}/update-users`, values);
    if (response.success) {
      showNotify(response.message);
      getTransfer(dataChanging.id);
    } else {
      showNotify(response.message, 'error');
    }
    setDataLoading(false);
  }

  async function ModalVerPDF(optionReport) {
    setDataLoading(true);
    const option = optionReport;
    const params = new URLSearchParams({
      showProviders: showProvidersInfo ? 1 : 0,
      showMarks: showMarksInfo ? 1 : 0,
      showCategories: showCategoriesInfo ? 1 : 0,
      showLines: showLinesInfo ? 1 : 0,
      showFamilies: showFamiliesInfo ? 1 : 0,
      showProdStock: showProdStock ? 1 : 0,
      option,
    }).toString();

    try {
      let pdfUrl;
      if (dataChanging.state === "PENDIENTE_FIRMA" || dataChanging.state === "PENDIENTE_APROBACION" || dataChanging.state === "APROBADO") {
        pdfUrl = await wsGetPdfPromise(`${entity}/${dataChanging.id}/generate-pdf?${params}`);
      } else if (dataChanging.state === "GENERADO") {
        pdfUrl = wsUrl(`${entity}/${dataChanging.id}/ver-pdf`);
      }
      setURLPDF(pdfUrl);
      setOpenPDF(true);
  
    } catch (error) {
      showNotify('Error al generar el PDF', 'error');
      setURLPDF(null);
    } finally {
      setDataLoading(false);
    }
  }

  useEffect(() => {
    if (dataChanging.zone) {
      const zone = zones.find((item) => item.description === dataChanging.zone);
      if (zone) {
        handleChange('base_zone_id', zone.id);
        listWarehouses(zone.logi_warehouse_id);
      }
    }
  }, [dataChanging.zone, zones]);

  useEffect(() => {
    if (dataChanging.WhsName) {
      const WhsName = warehouses.find((item) => item.WhsName === dataChanging.WhsName);
      if (WhsName) {
        handleChange('logi_warehouse_id', WhsName.id);
      }
    }
  }, [dataChanging.WhsName, warehouses]);

  useEffect(() => {
    setShowProducts(dataChanging?.state !== 'BORRADOR');
    setStateProduct(!(dataChanging?.state === 'PENDIENTE_FIRMA' || dataChanging?.state === 'BORRADOR'));
    setStateAprove(dataChanging?.state === 'PENDIENTE_APROBACION' || dataChanging?.state === 'APROBADO' || dataChanging?.state === 'GENERADO');
  }, [dataChanging?.state]);

  useEffect(() => {
    if (dataChanging.jefe_almacen_dia_name) {
      const jDia = jefeDia.find((item) => item.name === dataChanging.jefe_almacen_dia_name);
      if (jDia) {
        handleChange('jefe_almacen_dia_id', jDia.id);
      }
    }
  }, [dataChanging.jefe_almacen_dia_name, jefeDia]);
  useEffect(() => {
    if (dataChanging.jefe_almacen_noche_name) {
      const jNoche = jefeNoche.find((item) => item.name === dataChanging.jefe_almacen_noche_name);
      if (jNoche) {
        handleChange('jefe_almacen_noche_id', jNoche.id);
      }
    }
  }, [dataChanging.jefe_almacen_noche_name, jefeNoche]);
  useEffect(() => {
    if (dataChanging.auditor_name) {
      const Auditor = auditor.find((item) => item.name === dataChanging.auditor_name);
      if (Auditor) {
        handleChange('auditor_id', Auditor.id);
      }
    }
  }, [dataChanging.auditor_name, auditor]);

  const toggleProducts = () => {
    if (!showProducts && dataChanging?.products?.length > 0 && products?.length > 0) {
      const selectedProducts = products
        .filter((p) => dataChanging.products.includes(p.ItemName))
        .map((p) => ({
          ...p,
          comentario: '',
          cantidad_ingresada: 0,
          diferencia: 0,
        }));
      setProductSelecteds(selectedProducts);
    }
    setShowProducts((prev) => !prev);
  };

  const DeleteUltimoApellido = (name1, name2, maxLength = 30) => {
    let jefeDiaVar = name1.trim().split(" ");
    let jefeNocheVar = name2.trim().split(" ");
  
    while (`${jefeDiaVar.join(" ")}, ${jefeNocheVar.join(" ")}`.length > maxLength) {
      if (jefeNocheVar.length > jefeDiaVar.length) {
        jefeNocheVar.pop();
      } else if (jefeDiaVar.length > 1) {
        jefeDiaVar.pop();
      } else if (jefeNocheVar.length > 1) {
        jefeNocheVar.pop();
      } else {
        break;
      }
    }
  
    return `${jefeDiaVar.join(" ")}, ${jefeNocheVar.join(" ")}`;
  };
  
  const jefesAlmacenUnidos = (() => {
    const jefeDia = dataChanging?.jefe_almacen_dia_name?.trim() || "";
    const jefeNoche = dataChanging?.jefe_almacen_noche_name?.trim() || "";
  
    if (jefeDia === jefeNoche) {
      return jefeDia;
    }
  
    let fullNames = `${jefeDia}, ${jefeNoche}`;
  
    if (fullNames.length <= 30) {
      return fullNames;
    }
  
    return DeleteUltimoApellido(jefeDia, jefeNoche);
  })();

  return (
    <>
      <Toasty action={notify} />

      {openModalOutput && (
        <ModalOuput
          open={openModalOutput} 
          onClose={() => 
            setOpenModalOutput(false)
          }
          showNotify={showNotify}
          getTransfer= {getTransfer}
          data={modalData} />
      )}
      <ModalFull
        title="Toma de inventario"
        open={openPDF}
        setOpen={() => {
          setOpenPDF(!openPDF);
        }}
        iframe
      >
        <iframe src={openPDF ? urlPDF : undefined} width="100%" height="100%">
          No se pudo cargar el contenido.
          
        </iframe>
      </ModalFull>

      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment style={{ color: 'white' }} />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Toma de inventario {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <form
            id="formTransfer"
            onSubmit={(e) => {
              e.preventDefault();
              if (dataChanging.id) {
                updateTransfer();
              } else {
                saveTransfer();
              }
            }}
          >
            <InventoryHeader
              dataChanging={dataChanging} stateAprove={stateAprove} stateProduct={stateProduct} disabled={stateK} handleChange={handleChange} updateField={updateHeaderField} permission={permission}
              getTransfer={getTransfer} zones={zones} warehouses={warehouses} setWarehouses={setWarehouses} listWarehouses={listWarehouses}
              providers={providers} selectedProviders={selectedProviders} setSelectedProviders={setSelectedProviders}
              categories={categories} selectedCategories={selectedCategories} setSelectedCategories={setSelectedCategories}
              lines={lines} selectedLines={selectedLines} setSelectedLines={setSelectedLines}
              families={families} selectedFamilies={selectedFamilies} setSelectedFamilies={setSelectedFamilies}
              products={products} selectedProducts={selectedProducts} setSelectedProducts={setSelectedProducts}
              marks={marks} selectedMarks={selectedMarks} setSelectedMarks={setSelectedMarks}
              showProvidersInfo={showProvidersInfo} setShowProvidersInfo={setShowProvidersInfo}
              showMarksInfo={showMarksInfo} setShowMarksInfo={setShowMarksInfo}
              showCategoriesInfo={showCategoriesInfo} setShowCategoriesInfo={setShowCategoriesInfo}
              showLinesInfo={showLinesInfo} setShowLinesInfo={setShowLinesInfo}
              showFamiliesInfo={showFamiliesInfo} setShowFamiliesInfo={setShowFamiliesInfo}
              showProdStock={showProdStock} setShowProdStock={setShowProdStock}
              jefeDia={jefeDia} setJefeDia={setJefeDia} listJefeDia={listJefeDia}
              jefeNoche={jefeNoche} setJefeNoche={setJefeNoche} listJefeNoche={listJefeNoche}
              auditor={auditor} setAuditor={setAuditor} listAuditor={listAuditor}
            />

            {!dataChanging?.id && (
              <AllowedGuard permission={ConstantPermissions.LOGI_INVENTORIES_STORE}>
                <Button
                  color={props.themeContext.buttonColor}
                  style={{ marginTop: '15px', float: 'right' }}
                  onClick={confirmGenerateExpiring}
                >
                  Generar toma por vencer
                </Button>
              </AllowedGuard>
            )}

            {dataChanging?.state === 'BORRADOR' ? (
              <>
                <AllowedGuard
                  permission={
                    ConstantPermissions[type === 'GN' == 'LOGI_INVENTORIES_STORE']
                  }
                >
                  {/* BOTON PARA VALIDAR LOS DATOS Y PASAR AL SIGUIENTE ESTADO */}
                  <Button
                    color={props.themeContext.buttonColorSuccess}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      confirmChangeState('PENDIENTE_FIRMA');
                    }}
                  >
                    Validar
                  </Button>
                  {/* BOTON PARA MOSTRAR LA SECCIÓN DE PRODUCTOS */}
                  <Button
                    color={props.themeContext.buttonColorInfo}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={toggleProducts}
                  >
                    {showProducts ? 'Ocultar Productos' : 'Mostrar Productos'}
                  </Button>
                </AllowedGuard>
                {/* BTN ACTUALIZAR (oculto en tomas por vencer: no regenera detalle) */}
                {!dataChanging?.is_expiring && (
                  <AllowedGuard permission={ConstantPermissions[permission.update]}>
                    <Button
                      type="submit"
                      color={props.themeContext.buttonColorWarning}
                      style={{ marginTop: '15px', float: 'right' }}
                    >
                      Actualizar
                    </Button>
                  </AllowedGuard>
                )}
              </>
            ) : dataChanging?.state === 'PENDIENTE_FIRMA' ? (
              <>
                {/* BTN EDITAR */}
                <AllowedGuard permission={ConstantPermissions[permission.store]}>
                  <Button
                    color={props.themeContext.buttonColorWarning}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      confirmChangeState('BORRADOR');
                    }}
                  >
                    Editar
                  </Button>
                </AllowedGuard>
                {/* BTN SUBIR PDF */}
                {/* <AllowedGuard permission={ConstantPermissions[permission.store]}> */}
                  {/* <Button
                    color={props.themeContext.buttonColorDanger}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={(e) => {
                      e.currentTarget.querySelector('input').click();
                    }}
                  >
                    Subir PDF
                    <input
                      ref={inputPdf}
                      style={{ display: "none" }}
                      type="file"
                      accept="application/pdf"
                      onChange={(e) => {
                        if (e.currentTarget.files[0]) {
                          const fileName = e.currentTarget.files[0].name;
                          console.log('Archivo seleccionado:', fileName);
                          setNamePdf(fileName.split('.').slice(0, -1).join('.'));
                          confirmSendPDF(fileName);
                        }
                      }}
                    />
                  </Button> */}
                {/* </AllowedGuard> */}
                <AllowedGuard permission={ConstantPermissions[permission.store]}>
                  <Button
                    color={props.themeContext.buttonColorSuccess}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      confirmChangeState('PENDIENTE_APROBACION');
                    }}
                  >
                    Actualizar Estado
                  </Button>
                </AllowedGuard>
                {alert}
                {/* BTN ACTUALIZAR */}
                <AllowedGuard permission={ConstantPermissions[permission.update]}>
                  <Button
                    color={props.themeContext.buttonColorInfo}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      updateUsers({
                        jefe_almacen_dia: dataChanging.jefe_almacen_dia,
                        jefe_almacen_noche: dataChanging.jefe_almacen_noche,
                        auditor: dataChanging.auditor,
                        jefe_almacen_dia_id: dataChanging.jefe_almacen_dia_id,
                        jefe_almacen_noche_id: dataChanging.jefe_almacen_noche_id,
                        auditor_id: dataChanging.auditor_id,
                      });
                    }}
                  >
                    Actualizar usuarios
                  </Button>
                </AllowedGuard>
              </>
            ) : dataChanging?.state === 'GENERADO' ? (
              <>
                {/* BTN APROBAR PDF SUBIDO */}
                <AllowedGuard permission={ConstantPermissions[permission.update]}>
                  <Button
                    color={props.themeContext.buttonColorSuccess}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      confirmChangeState('PENDIENTE_APROBACION');
                    }}
                  >
                    Confirmar PDF
                  </Button>
                </AllowedGuard>
                {/* BTN VER PDF */}
                <AllowedGuard permission={ConstantPermissions[permission.store]}>
                  <Button
                    color={props.themeContext.buttonColorInfo}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      ModalVerPDF();
                    }}
                  >
                    Ver PDF subido
                  </Button>
                </AllowedGuard>
                {/* BTN CANCELAR PDF SUBIDO */}
                <AllowedGuard permission={ConstantPermissions[permission.update]}>
                  <Button
                    color={props.themeContext.buttonColorDanger}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      confirmChangeState('PENDIENTE_FIRMA');
                    }}
                  >
                    Cancelar PDF
                  </Button>
                </AllowedGuard>
              </>
            ) : dataChanging?.state === 'PENDIENTE_APROBACION' ? (
              <>
                {/* BOTON PARA APROBAR */}
                <AllowedGuard permission={ConstantPermissions[permission.confirm]}>
                  <Button
                    color={props.themeContext.buttonColorSuccess}
                    style={{ marginTop: '15px', float: 'right', marginRight: '10px' }}
                    onClick={() => {
                      // confirmAprove();
                      confirmChangeState('APROBADO');
                    }}
                  >
                    Aprobar
                  </Button>
                </AllowedGuard>
                {alertAprove}
              </>
            ) : dataChanging?.state === 'APROBADO' ? (
              <>
                <AllowedGuard permission={ConstantPermissions.LOGI_INVENTORIES_STORE}>
                  <Button
                    color={props.themeContext.buttonColorSuccess}
                    style={{ marginTop: '15px', float: 'right' }}
                    disabled={
                      dataChanging?.logi_entry_id !== null || 
                      !filterProductsByDifference(diff => diff > 0).length
                    }
                    onClick={() => {
                      const entries = filterProductsByDifference(diff => diff > 0);
                      setOpenModalOutput(true);
                      setModalData({
                        type: 'ET',
                        idRegister: dataChanging?.id,
                        warehouseId: dataChanging?.logi_warehouse_id,
                        warehouseName: dataChanging?.WhsName,
                        zoneId: dataChanging?.base_zone_id,
                        zoneName: dataChanging?.zone,
                        auditor: dataChanging?.auditor_name,
                        almacenero: jefesAlmacenUnidos,
                        products: entries,
                      });
                    }}
                  >
                    Generar Entradas
                  </Button>

                  <Button
                    color={props.themeContext.buttonColorDanger}
                    style={{ marginTop: '15px', float: 'right' }}
                    disabled={
                      dataChanging?.logi_output_id !== null || 
                      !filterProductsByDifference(diff => diff < 0).length
                    }
                    onClick={() => {
                      const outputs = filterProductsByDifference(diff => diff < 0);
                      setOpenModalOutput(true);
                      setModalData({
                        type: 'SE',
                        idRegister: dataChanging?.id,
                        warehouseId: dataChanging?.logi_warehouse_id,
                        warehouseName: dataChanging?.WhsName,
                        zoneId: dataChanging?.base_zone_id,
                        zoneName: dataChanging?.zone,
                        auditor: dataChanging?.auditor_name,
                        almacenero: jefesAlmacenUnidos,
                        products: outputs,
                      });
                    }}
                  >
                    Generar Salidas
                  </Button>
                </AllowedGuard>
              </>
            ) : undefined}

            {dataChanging?.state && dataChanging.state !== 'BORRADOR' ? (
              <>
                {/* BTN DESCARGAR PDF Normal*/}
                <AllowedGuard permission={ConstantPermissions[permission.store]}>
                  <Button
                    color={props.themeContext.buttonColorPrimary}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      ModalVerPDF("general");
                    }}
                  >
                    Ver PDF
                  </Button>
                </AllowedGuard>
                {/* BTN DESCARGAR PDF productos con diferencia*/}
                <AllowedGuard permission={ConstantPermissions[permission.store]}>
                  <Button
                    color={props.themeContext.buttonColorPrimary}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      ModalVerPDF("diferencia");
                    }}
                  >
                    Ver PDF productos con diferencia
                  </Button>
                </AllowedGuard>
                {/* BTN DESCARGAR PDF productos a vencer*/}
                <AllowedGuard permission={ConstantPermissions[permission.store]}>
                  <Button
                    color={props.themeContext.buttonColorPrimary}
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => {
                      ModalVerPDF("vencimiento");
                    }}
                  >
                    Ver PDF productos a vencer
                  </Button>
                </AllowedGuard>
              </>
            ) : undefined}

            {!isInitializingWithId.current ? (
              <AllowedGuard permission={ConstantPermissions.LOGI_INVENTORIES_STORE}>
                <Button
                  type="submit"
                  color={props.themeContext.buttonColorSuccess}
                  style={{ marginTop: '15px', float: 'right' }}
                  disabled={stateK}
                >
                  Guardar
                </Button>
              </AllowedGuard>
            ) : undefined}
          </form>
        </CardBody>
      </Card>
      {showProducts && isInitializingWithId.current && (
        <DetailKardex
          type={type}
          entity={entity}
          permission={permission}
          dataChanging={dataChanging}
          productSelecteds={productSelecteds}
          setProductSelecteds={setProductSelecteds}
          showNotify={showNotify}
          getTransfer={getTransfer}
          stateK={stateK}
          stateA={stateA}
          setStateK={setStateA}
          showProdStock={showProdStock}
        />
      )}
      {alertAprove}
    </>
  );
});
